// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2EhIf","item":"PaymentsMobile_item__2k9tS","label":"PaymentsMobile_label__3t598","amount":"PaymentsMobile_amount__2vkQu"};